import { Button, ModalWindow, UIHeading2, UIText1 } from '@cian/ui-kit';
import * as React from 'react';

import illustration from './assets/illustration.svg';
import * as styles from './styles.css';

export interface IReviewsToAppModalProps {
  onClose(): void;
  onConfirm?(): void;
  open: boolean;
}

export function ReviewsGoToAppModal({ open, onClose, onConfirm }: IReviewsToAppModalProps) {
  return (
    <ModalWindow maxWidth={640} open={open} onClose={onClose} portal>
      <div className={styles['container']}>
        <div className={styles['main-content']}>
          <img className={styles['img']} src={illustration} alt="QR код" />
          <UIHeading2>Скачайте приложение — отсканируйте QR-код</UIHeading2>
          <UIText1>Пока оставлять и&nbsp;читать отзывы можно только там</UIText1>
        </div>
        <Button theme="fill_primary" size="XS" onClick={onConfirm} type="button">
          Не сейчас
        </Button>
      </div>
    </ModalWindow>
  );
}
